interface OwnerFeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const OwnerFeatureCard = ({
  icon,
  title,
  description,
}: OwnerFeatureCardProps) => (
  <div className="text-center">
    <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
      {icon}
    </div>

    <h3 className="text-lg md:text-xl font-semibold mb-4 text-gray-900">
      {title}
    </h3>

    <p className="text-gray-600 leading-relaxed">{description}</p>
  </div>
);

export default OwnerFeatureCard;
